export default class Mask {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return 'JJJ-JJJJ';
    }

    birthdate() {
        return '2999-19-39';
    }
}
